import { Icons } from './icons/icon-set';

export function Toast({ msg }: { msg: string }) {
  if (!msg) return null;
  return (
    <div class="toast">
      <Icons.check size={16} /> {msg}
    </div>
  );
}
